import { render, staticRenderFns } from "./blockCard.vue?vue&type=template&id=353d86dd&scoped=true"
import script from "./blockCard.vue?vue&type=script&lang=js"
export * from "./blockCard.vue?vue&type=script&lang=js"
import style0 from "./blockCard.vue?vue&type=style&index=0&id=353d86dd&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353d86dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3875257498/src/codestar-connections.ap-northeast-1.amazonaws.com/git-http/364953906322/ap-northeast-1/84d36ee7-16b8-4e80-bff0-7e6a249efe8b/OwlTing/owlnest_booking_engine/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('353d86dd')) {
      api.createRecord('353d86dd', component.options)
    } else {
      api.reload('353d86dd', component.options)
    }
    module.hot.accept("./blockCard.vue?vue&type=template&id=353d86dd&scoped=true", function () {
      api.rerender('353d86dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/blockCard.vue"
export default component.exports